import { useRecordContext } from "react-admin";
import RejectModal from "components/Alumni/AlumniProfiles/RejectModal";
import { careerCenterRequests } from "api/careerCenterApi";

const RejectEmployer = () => {
  const record = useRecordContext();

  return (
    <RejectModal
      request={careerCenterRequests.rejectEmployer(record?.id)}
      titleContent="Отказ на профил на работодател"
    />
  );
};

export default RejectEmployer;
